import twCustom from '@/i18n/langs/tw.json'

export default {
	...twCustom
}
